/**
 * React-hook для permission checks (Порція 3.0.5.5).
 *
 * Читає `/auth/me` через React Query (queryKey=['me'], який уже
 * запитується у AppLayout) — нових запитів не робить. Якщо me ще
 * loading → повертає has=false (під час loading кнопки сховані,
 * але це короткочасно і UX-нейтрально).
 */
import { useQuery } from '@tanstack/react-query';
import { getMe } from '@/api/auth';
import { hasAnyPermission, hasPermission } from './permissions';

export function usePermissions() {
  const me = useQuery({ queryKey: ['me'], queryFn: getMe });
  return {
    me: me.data,
    isLoading: me.isLoading,
    // ч.1084: список = «будь-яке з прав» (сторінка «Початкові дані» — імпорт
    // довідників АБО вступні залишки). Рядок — як і раніше, одне право.
    has: (code: string | readonly string[]) => (typeof code === 'string'
      ? hasPermission(me.data, code) : hasAnyPermission(me.data, code)),
    hasAny: (codes: readonly string[]) => hasAnyPermission(me.data, codes),
    isOwnerOrAdmin:
      me.data?.tenant_role === 'OWNER' || me.data?.tenant_role === 'ADMIN',
  };
}
